import { define } from '../../utils';

import recaptchaPreview from './preview.png';

function RecaptchaPreview() {
  return <>
    <img src={recaptchaPreview} width="304" height="78" />
  </>
}

function RecaptchaHTML({ origin }) {
  return <>
    {
      `{{#if @config.system.recaptcha.recaptcha_api_key}}
        {{>common/recaptcha origin="${origin}" }}
      {{/if}}
    `}
  </>
}

export default define('recaptcha', RecaptchaPreview, RecaptchaHTML)
  .build()
